// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1pEKb","inputWrap":"CustomTip_inputWrap__2y_Dy"};